import datadogLogger from 'app/error/logError/datadogLogger';
import consoleLogger from 'app/error/logError/consoleLogger';

const logError = (error, context) => {
  consoleLogger(error, context);
  datadogLogger(error, context);
};

export default logError;
